module.exports = __webpack_public_path__ + "static/media/user.0a8c656b.svg";